import React from "react";
import { observer } from "mobx-react";
import { useParams } from "react-router-dom";

import BookmarkList from "@app/components/document/bookmark/list";
import { getBookmarkLink } from "@app/components/document/bookmark/utils";

const Bookmarks = observer(({ readonly = false }) => {
    const { project } = useParams();

    const onBookmarkOpen = (bookmark) => {
        const link = getBookmarkLink({ bookmark, baseUrl: `/fp/r/${project}` });
        window.open(link, "_blank").focus();
    };

    return <BookmarkList onOpen={onBookmarkOpen} readonly={readonly} />;
});

export default Bookmarks;
